import React from 'react';
import SliderHome from '../SliderHome/SliderHome';
import GeneralServices from '../Services/GeneralServices/GeneralServices';
import Profetionals from '../Profetionals/Profetionals';
import ImagePolygon from '../ImagePolygon/ImagePolygon';
import Benefits from '../Benefits/Benefits';
import Protection from '../Protection/Protection';
import Clientes from '../Clientes/Clientes';

const Home = () => {
  return (
    <>
      <SliderHome />
      <GeneralServices />
      <Profetionals />
      <ImagePolygon />
      <Benefits />
      <Protection />
      <Clientes />
    </>

  )
}

export default Home